import React from "react";
import { StyledChip } from "./style.js";

function Chip(props) {
    return <StyledChip {...props} />;
}

export default Chip;
